import * as React from 'react';

import cn from 'classnames';

import { Icon } from '@base/components/Icon';

import { IconAppCross, IconAppMenu } from '@icons';

import * as s from './FullscreenAppHeader.scss';

interface IFullscreenAppHeaderMenuItems {
	[key: string]: () => void;
}

interface IFullscreenAppHeaderProps {
	appName: string;
	items?: IFullscreenAppHeaderMenuItems;
	onClose: () => void;
}

export function FullscreenAppHeader(props: IFullscreenAppHeaderProps) {
	const { appName, items, onClose } = props;
	const [showMenu, setShowMenu] = React.useState(false);
	const toggleShowMenu = () => setShowMenu(!showMenu);
	const onItemClick = (handler: () => void) => () => {
		handler();
		toggleShowMenu();
	};

	return <header className={s.header}>
		<Icon
			glyph={IconAppCross}
			className={s.headerClose}
			onClick={onClose}
		/>
		<h1 className={s.headerName}>{appName}</h1>
		{items
			? <>
				<Icon
					glyph={IconAppMenu}
					className={s.headerMenuIcon}
					onClick={toggleShowMenu}
				/>
				<div className={cn(s.headerMenuList, { [s._visible]: showMenu })}>
					{Object.keys(items).map((key) =>
						<div
							key={key}
							className={s.headerMenuListItem}
							onClick={onItemClick(items[key])}
						>
							{key}
						</div>)}
				</div>
			</>
			: null}
	</header>;
};
